export const categories = [
  { id: "colares", label: "Colares", count: 120 },
  { id: "brincos", label: "Brincos", count: 84 },
  { id: "pulseiras", label: "Pulseiras", count: 62 },
  { id: "aneis", label: "Anéis", count: 48 },
  { id: "relogios", label: "Relógios", count: 36 },
  { id: "oculos", label: "Óculos", count: 22 },
  { id: "bolsas", label: "Bolsas", count: 31 },
  { id: "carteiras", label: "Carteiras", count: 19 },
  { id: "conjuntos", label: "Conjuntos", count: 27 },
  { id: "todos", label: "Todos os produtos", count: 349 },
];

export const priceRanges = [
  { id: "p1", label: "Até R$ 50,00" },
  { id: "p2", label: "R$ 50,00 – R$ 100,00" },
  { id: "p3", label: "R$ 100,00 – R$ 200,00" },
  { id: "p4", label: "R$ 200,00 – R$ 300,00" },
  { id: "p5", label: "Acima de R$ 300,00" },
];

export const colors = [
  { id: "dourado", label: "Dourado", hex: "#c9a24b" },
  { id: "prata", label: "Prata", hex: "#c9ccd1" },
  { id: "rose", label: "Rosé", hex: "#e0a99b" },
  { id: "preto", label: "Preto", hex: "#2b2723" },
  { id: "verde", label: "Verde", hex: "#5d7d63" },
  { id: "vermelho", label: "Vermelho", hex: "#a8462f" },
  { id: "azul", label: "Azul", hex: "#3f5a78" },
  { id: "outras", label: "Outras", hex: "#d9d2c7" },
];

export const materials = [
  { id: "aco", label: "Aço Inoxidável" },
  { id: "folheado", label: "Folheado a Ouro" },
  { id: "prata925", label: "Prata 925" },
  { id: "perola", label: "Pérola" },
  { id: "zirconia", label: "Zircônia" },
  { id: "couro", label: "Couro" },
  { id: "outros", label: "Outros" },
];

export const sortOptions = [
  { id: "relevancia", label: "Mais relevantes" },
  { id: "vendidos", label: "Mais vendidos" },
  { id: "menor", label: "Menor preço" },
  { id: "maior", label: "Maior preço" },
  { id: "novidades", label: "Novidades" },
];

export interface Product {
  inStock?: boolean;
  id: number;
  name: string;
  price: number;
  installments: number;
  installmentValue: number;
  image: string;
  color: string;
  material: string;
  variantId?: number;
  categoryIds?: number[];
  attributes?: Record<string, string[]>;
}

export const products: Product[] = [
  {
    id: 1,
    name: "Colar Coração Minimal",
    price: 129.9,
    installments: 12,
    installmentValue: 10.83,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20woman%20neck%20wearing%20a%20delicate%20gold%20necklace%20with%20a%20small%20heart%20pendant%2C%20soft%20warm%20beige%20studio%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20natural%20soft%20lighting%2C%20minimal%20clean%20aesthetic&width=600&height=750&seq=colar-coracao-minimal-01&orientation=portrait",
  },
  {
    id: 2,
    name: "Colar Duplo Elegance",
    price: 159.9,
    installments: 12,
    installmentValue: 13.33,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Layered%20double%20gold%20chain%20necklace%20on%20a%20woman%20neck%20with%20bare%20shoulders%2C%20soft%20warm%20beige%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20natural%20soft%20lighting%2C%20minimal%20clean%20aesthetic&width=600&height=750&seq=colar-duplo-elegance-02&orientation=portrait",
  },
  {
    id: 3,
    name: "Colar Medalha Clássica",
    price: 139.9,
    installments: 12,
    installmentValue: 11.66,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Round%20gold%20medal%20coin%20necklace%20worn%20on%20a%20woman%20neck%20with%20black%20top%2C%20soft%20warm%20beige%20studio%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20natural%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-medalha-classica-03&orientation=portrait",
  },
  {
    id: 4,
    name: "Colar Ponto de Luz Verde",
    price: 149.9,
    installments: 12,
    installmentValue: 12.49,
    color: "verde",
    material: "zirconia",
    image:
      "https://readdy.ai/api/search-image?query=Delicate%20gold%20necklace%20with%20a%20single%20small%20green%20emerald%20gemstone%20pendant%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-ponto-luz-verde-04&orientation=portrait",
  },
  {
    id: 5,
    name: "Colar Pérola Moderna",
    price: 179.9,
    installments: 12,
    installmentValue: 14.99,
    color: "prata",
    material: "perola",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20gold%20necklace%20with%20a%20single%20round%20white%20pearl%20pendant%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20studio%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-perola-moderna-05&orientation=portrait",
  },
  {
    id: 6,
    name: "Colar Inicial Personalizada",
    price: 169.9,
    installments: 12,
    installmentValue: 14.16,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Gold%20initial%20letter%20A%20pendant%20necklace%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20personalized%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20clean%20aesthetic&width=600&height=750&seq=colar-inicial-06&orientation=portrait",
  },
  {
    id: 7,
    name: "Colar Riviera Zircônia",
    price: 239.9,
    installments: 12,
    installmentValue: 19.99,
    color: "prata",
    material: "zirconia",
    image:
      "https://readdy.ai/api/search-image?query=Riviera%20tennis%20necklace%20with%20sparkling%20clear%20zirconia%20stones%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-riviera-zirconia-07&orientation=portrait",
  },
  {
    id: 8,
    name: "Colar Trevo da Sorte",
    price: 149.9,
    installments: 12,
    installmentValue: 12.49,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Four%20leaf%20clover%20gold%20pendant%20necklace%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20studio%20background%2C%20lucky%20charm%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-trevo-sorte-08&orientation=portrait",
  },
  {
    id: 9,
    name: "Colar Cravejado Luxo",
    price: 259.9,
    installments: 12,
    installmentValue: 21.66,
    color: "dourado",
    material: "zirconia",
    image:
      "https://readdy.ai/api/search-image?query=Gold%20necklace%20densely%20paved%20with%20shimmering%20zirconia%20crystals%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20luxury%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20glamorous%20minimal%20aesthetic&width=600&height=750&seq=colar-cravejado-luxo-09&orientation=portrait",
  },
  {
    id: 10,
    name: "Colar Gotas Delicadas",
    price: 169.9,
    installments: 12,
    installmentValue: 14.16,
    color: "dourado",
    material: "perola",
    image:
      "https://readdy.ai/api/search-image?query=Gold%20necklace%20with%20small%20dangling%20pearl%20drop%20charms%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20studio%20background%2C%20delicate%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-gotas-delicadas-10&orientation=portrait",
  },
  {
    id: 11,
    name: "Colar Duplo Círculos",
    price: 159.9,
    installments: 12,
    installmentValue: 13.33,
    color: "dourado",
    material: "folheado",
    image:
      "https://readdy.ai/api/search-image?query=Necklace%20with%20two%20interlocking%20gold%20circle%20rings%20pendant%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20modern%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20clean%20aesthetic&width=600&height=750&seq=colar-duplo-circulos-11&orientation=portrait",
  },
  {
    id: 12,
    name: "Colar Com Pedra Natural",
    price: 189.9,
    installments: 12,
    installmentValue: 15.83,
    color: "verde",
    material: "zirconia",
    image:
      "https://readdy.ai/api/search-image?query=Gold%20necklace%20with%20a%20natural%20green%20gemstone%20teardrop%20pendant%20on%20a%20woman%20neck%2C%20soft%20warm%20beige%20background%2C%20bohemian%20luxury%20jewelry%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-pedra-natural-12&orientation=portrait",
  },
];
